import './scss/rivandy.scss';
import './scss/ranking.scss';
import React, { useState } from 'react';
import { useEffect } from 'react';
import Video from './Video';
import Faction from './Faction';
import { useSelector } from 'react-redux';
import Fade from 'react-reveal/Fade';
import axios from 'axios';

function Ranking() {


  const settings = useSelector(state => state);
  const [classement, setRank] = useState(null);
  const [total, setTotal] = useState(0);


  const [filterName, setFilterName] = useState('');
  const [numberPerPage, setNumberPerPage] = useState(50);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasError, setHasError] = useState(false);

  let cpt = 0;

  useEffect(() => {
    const fetch = async () => {
      await axios.get(`https://rivandy.com:3003/game/GetRanking?pageNumber=${pageNumber}&filterName=${filterName}&numberPerPage=${numberPerPage}`).then((result) => {
        setRank(result.data.result);
        setTotal(result.data.total);
        setHasError(false)
      }).catch((e) => {
        setRank(null);
        setTotal(0);
        setHasError(true)
      })


    }
    fetch();
  }, [filterName, numberPerPage, pageNumber]);

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handleFilterChange = (event) => {
    setFilterName(event.target.value);
  };

  const handleNumberPerPageChange = (event) => {
    setNumberPerPage(event.target.value);
  };

  const result = classement && classement.map((joueur) => {
    cpt++;
    return (
      <tr key={joueur.username || joueur.steamprofile}>
        <td key={cpt}>{cpt}</td>
        <td className='nameTD'><a target="_blank" href={joueur.steamprofile}>{joueur.avatarId.endsWith(".jpg") ? <img src={joueur.avatarId}></img> : null}</a><a target="_blank" href={joueur.steamprofile}>{joueur.username}</a></td>
        <td>{joueur.rankedPoint}</td>
        {/* <td>{joueur.win} - {joueur.lose}</td> */}
      </tr>
    )
  });


  return (
    [<section className='rankingPage separator'>
      <section id="ranking-section">
        <section>


          <aside className='filterPage'>
            <aside className='textFilter'>
              <label>Filter</label>
              <input type="text" value={filterName} onChange={handleFilterChange} />
            </aside>
            <aside className='numberPerPageFilter'>
              <article>
                {total / numberPerPage < pageNumber && pageNumber > 1 ? <button onClick={() => handlePageChange(pageNumber - 1)}>Previous</button> : null}
                {pageNumber > 2 ? <button onClick={() => handlePageChange(1)}>1</button> : null}
                {total / numberPerPage > pageNumber - 1 && pageNumber > 1 ? <button onClick={() => handlePageChange(pageNumber - 1)}>{pageNumber - 1}</button> : null}
                <button className='selectedPage' disabled> {pageNumber}</button>
                {Math.ceil(total / numberPerPage) >= pageNumber + 1 ? <button onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</button> : null}
                {/* Vous pouvez ajouter autant de boutons de page supplémentaires que nécessaire */}
                {total / numberPerPage > pageNumber ? <button onClick={() => handlePageChange(pageNumber + 1)}>Next</button> : null}

              </article>
              <select value={numberPerPage} onChange={handleNumberPerPageChange}>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>

            </aside>

          </aside>


          <table id="tableRank" cellSpacing="0">
            <tr className='tableTitles'><th>RANK</th><th className='nameTH'>NAME</th><th>SCORE (RP)</th></tr>
            {result}
            {hasError ? <p className='error'>We couldn't find any matches. Would you like to try another search?</p> : null}
          </table>
        </section>
      </section>
    </section>]
  );
}

export default Ranking;
